import React from "react";
import { motion } from "framer-motion";
import { Link } from 'react-router-dom';

const HeroSection = () => (
  <section className="relative overflow-hidden bg-gradient-to-br from-slate-950 via-primary to-primary-light px-6 py-20 text-white">
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_rgba(212,166,74,0.30),transparent_24%),radial-gradient(circle_at_bottom_left,_rgba(125,211,252,0.12),transparent_18%)]" />
    <div className="absolute inset-x-0 bottom-0 h-28 bg-gradient-to-t from-[#f8fafc] to-transparent" />
    <div className="relative z-10 mx-auto flex max-w-7xl flex-col items-center justify-center gap-10 text-center md:flex-row md:text-left">
      <motion.div
        initial={{ opacity: 0, x: -100 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 1 }}
        className="max-w-3xl"
      >
        <motion.p
          className="mb-4 inline-block rounded-full border border-secondary/35 bg-white/5 px-4 py-2 text-sm font-semibold uppercase tracking-[0.22em] text-secondary-light"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          Growth. Strategy. Results.
        </motion.p>

        <motion.h1
          className="mb-5 text-balance text-4xl font-black leading-tight text-white drop-shadow-[0_16px_40px_rgba(0,0,0,0.32)] sm:text-5xl md:text-6xl"
          initial={{ opacity: 0, y: 18 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.5 }}
        >
          We turn traffic into revenue for ambitious brands.
        </motion.h1>

        <motion.p
          className="mx-auto mb-8 max-w-2xl text-xl text-slate-200 md:mx-0 md:text-2xl"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1 }}
        >
          RT Jobspot helps businesses grow with high-impact digital marketing,
          performance campaigns, and conversion-focused strategies designed for long-term success.
        </motion.p>

        <motion.div
          className="flex flex-col items-center justify-center gap-4 sm:flex-row md:justify-start"
          initial={{ y: 50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 1.2 }}
        >
          <motion.a
            href="#contact"
            className="inline-block rounded-full bg-gradient-to-r from-secondary-light to-secondary px-8 py-3 font-bold text-slate-950 shadow-[0_16px_35px_rgba(212,166,74,0.45)] transition-all hover:scale-105"
            whileHover={{
              scale: 1.08,
              boxShadow: "0 0 25px rgba(212,166,74,0.6)",
            }}
            whileTap={{ scale: 0.95 }}
          >
            Get a Free Consultation
          </motion.a>

          <Link
            to="/creator-registration"
            className="inline-block rounded-full border border-white/25 bg-white/5 px-8 py-3 font-bold text-white transition hover:bg-white/10"
          >
            Register as Creator
          </Link>
        </motion.div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, x: 80 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.9, delay: 0.8 }}
        className="relative w-full max-w-md"
      >
        <div className="rounded-[32px] border border-white/10 bg-white/5 p-5 shadow-[0_30px_60px_rgba(0,0,0,0.32)] backdrop-blur-xl">
          <div className="rounded-[24px] bg-gradient-to-br from-slate-900 via-[#111827] to-[#0f172a] p-5">
            <div className="mb-5 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="flex h-11 w-11 items-center justify-center rounded-xl bg-gradient-to-br from-secondary-light to-secondary text-lg font-black text-slate-950">
                  RT
                </div>
                <div>
                  <div className="text-xs uppercase tracking-[0.25em] text-slate-400">Brand</div>
                  <div className="text-lg font-bold text-white">RT Jobspot</div>
                </div>
              </div>
              <span className="rounded-full border border-emerald-400/30 bg-emerald-500/10 px-2 py-1 text-[10px] font-bold uppercase tracking-[0.2em] text-emerald-300">
                Live
              </span>
            </div>

            <div className="grid gap-3 sm:grid-cols-2">
              {[
                ['180+', 'Campaigns'],
                ['3x', 'ROI Growth'],
                ['94%', 'Retention'],
                ['24/7', 'Monitoring'],
              ].map(([value, label]) => (
                <div key={label} className="rounded-2xl border border-white/10 bg-white/5 p-3">
                  <div className="text-2xl font-black text-secondary-light">{value}</div>
                  <div className="text-xs uppercase tracking-[0.18em] text-slate-300">{label}</div>
                </div>
              ))}
            </div>

            <div className="mt-5 rounded-2xl border border-secondary/30 bg-secondary/10 p-4">
              <div className="mb-2 text-xs uppercase tracking-[0.2em] text-secondary-light">Performance</div>
              <div className="mb-3 h-2.5 overflow-hidden rounded-full bg-white/10">
                <div className="h-full w-[82%] rounded-full bg-gradient-to-r from-secondary-light to-secondary" />
              </div>
              <div className="flex items-center justify-between text-sm text-slate-200">
                <span>Growth velocity</span>
                <span className="font-bold text-white">82%</span>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  </section>
);

export default HeroSection;
